export default __webpack_public_path__ + "static/media/GigEngineerLogo.866f7671.png";